import { BackspaceIcon } from '@/components/icons/svg-icons';
import { useTranslations } from 'next-intl';
import clsx from 'clsx';
import { mePanelStyle } from '../me-panel/me-panel.style';

interface StakeKeypadProps {
  isOpen: boolean;
  className?: string;
  onNumberPress: (value: string) => void;
  onBackspacePress: () => void;
  clickDone: () => void;
}

/** Profile Panel - Stake 設定小鍵盤 (for deafult stake & quick stake) */
export const StakeKeypad = ({
	isOpen,
	className,
	onNumberPress,
	onBackspacePress,
	clickDone
}: StakeKeypadProps) => {
	const t = useTranslations('General');

	return (
		<div className={clsx('set-stake__keypad', className)} data-show={isOpen}>
			<div className="keypad keypad--default-mini">
				<div className="keypad__numbers">
					<div className="keypad-btn" onClick={() => onNumberPress('1')}>1</div>
					<div className="keypad-btn" onClick={() => onNumberPress('2')}>2</div>
					<div className="keypad-btn" onClick={() => onNumberPress('3')}>3</div>
					<div className="keypad-btn" onClick={() => onNumberPress('4')}>4</div>
					<div className="keypad-btn" onClick={() => onNumberPress('5')}>5</div>
					<div className="keypad-btn" onClick={() => onNumberPress('6')}>6</div>
					<div className="keypad-btn" onClick={() => onNumberPress('7')}>7</div>
					<div className="keypad-btn" onClick={() => onNumberPress('8')}>8</div>
					<div className="keypad-btn" onClick={() => onNumberPress('9')}>9</div>
					<div className="keypad-btn" onClick={() => onNumberPress('0')}>0</div>
					<div className="keypad-btn" onClick={() => onNumberPress('00')}>00</div>
					<div className="keypad__backspace" onClick={onBackspacePress}>
						<div className="keypad-btn">
							<BackspaceIcon />
						</div>
					</div>
				</div>
				<div className="keypad__submit" onClick={clickDone}>
					<div className="keypad-btn">{t('lbl_Done')}</div>
				</div>
			</div>
			<button className={clsx('btn', mePanelStyle.doneButton)} onClick={clickDone}>
				<span className="btn__text">{t('lbl_Done')}</span>
			</button>
		</div>
	);
}